import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ignatiusIconNames, opengovFilledIconNames, opengovOutlinedIconNames } from './icons.constant';
import { UntypedFormGroup } from '@angular/forms';
import { RouteService } from 'src/app/core/services/route.service';
import { SubSink } from 'subsink';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss']
})
export class IconsComponent implements OnInit, OnDestroy {
  @Input('fontSize') fontSize:any = '30';
  @Input('height') height:any = '240';
  @Input('startSize') startSize:any = '30';
  @Input('form') form!: UntypedFormGroup;

  icons: string[] = [];
  displayedIcons: string[] = [];
  searchTerm: string = '';
  batchSize: number = 20;
  lastLoadedIndex: number = 0;
  isOutLined:boolean = false;
  bgColor:string = 'var(--background-neutral-light)';
  iconColor:string = 'var(--foreground-tertiary)';
  IgnatiusIconColor:string = '#fff';
  openGovIconColor:string = 'var(--foreground-tertiary)';
  subsink: SubSink = new SubSink();

  constructor(
    private route:RouteService,
    private commonService:CommonService
  ) { }

  ngOnInit(): void {
    this.icons = this.availableIconNames();
    this.batchSize = +this.startSize;
    this.iconColor = this.form.value?.IconColor || this.iconColorDefault;
    this.loadMoreIcons();
    this.subsink.add(
      this.form.controls?.IconColor?.valueChanges?.subscribe(value => {
        this.iconColor = value;
      }),
      this.route.fork(this.routeChange.bind(null)),
      this.commonService.updateTheme.subscribe(() => {
        this.icons = this.commonService.isIgnatiusThemeApplied ? ignatiusIconNames : opengovFilledIconNames;
        this.displayedIcons = [];
        this.lastLoadedIndex = 0;
        this.batchSize = +this.startSize;
        this.loadMoreIcons();
      })
    )
  }

  get iconColorDefault() {
    return this.commonService.isIgnatiusThemeApplied ? this.IgnatiusIconColor : this.openGovIconColor;
  }

  get bgColorDefault() {
    return this.commonService.isIgnatiusThemeApplied ? 'rgb(146 145 153)' : this.bgColor;
  }

  routeChange = () => {
    this.searchTerm = '';
    this.lastLoadedIndex = 0;
    this.batchSize = +this.startSize;
    this.displayedIcons = [];
    this.loadMoreIcons();
  }

  ngOnChanges(change:SimpleChanges){
    if(change.form.currentValue !== change.form.previousValue){
      this.iconColor = change.form.currentValue.value?.IconColor || this.iconColorDefault;
    }
  }

  availableIconNames() {
    return this.commonService.isIgnatiusThemeApplied ? ignatiusIconNames : opengovFilledIconNames;
  }


  onSearchChange(): void {
    this.displayedIcons = this.icons.filter(icon => icon.toLowerCase().includes(this.searchTerm.replace(/\s/g, '').toLowerCase())).slice(0,30);
    this.lastLoadedIndex = 0;
    if(!this.searchTerm){
      this.displayedIcons = [];
      this.batchSize = 30;
      this.loadMoreIcons();
    }
  }

  onScroll(): void {
    this.loadMoreIcons();
  }

  loadMoreIcons(): void {
    const nextBatch = this.icons.slice(this.lastLoadedIndex, this.lastLoadedIndex + this.batchSize);
    this.displayedIcons = this.displayedIcons.concat(nextBatch);
    this.lastLoadedIndex += this.batchSize;
    this.batchSize = 10;
  }

  setSearch = (event: any) => {
    // if (event.target.value.length < 3 && event.target.value.length > 0) return;
    this.searchTerm = event.target.value;
    this.onSearchChange();
  };

  showOutlinedIcons(){
    this.isOutLined = !this.isOutLined;
    if(!this.commonService.isIgnatiusThemeApplied) {
        this.icons = this.isOutLined ? opengovOutlinedIconNames: opengovFilledIconNames;
        this.displayedIcons = [];
        this.lastLoadedIndex = 0;
        this.batchSize = +this.startSize;
        this.loadMoreIcons();
    }
  }

  getIconClass(icon:any){
    if(this.commonService.isIgnatiusThemeApplied){
      if(this.isOutLined){
        return 'fl-' + icon + '-outlined';
      }
      return 'fluent-' + icon;
    } else {
      if(this.isOutLined){
        return 'material-icons-outlined material-icons-outlined-' + icon;
      }
      return 'material-icons material-icons-' + icon;
    }
  }

  getTitle(icon:any){
    return this.commonService.isIgnatiusThemeApplied ? icon.replace(/([a-z])([A-Z])/g, '$1 $2') : icon.split('_').map((n:string) => n[0].toUpperCase() + n.slice(1)).join('');
  }

  colorChange(event:any){
    this.form.controls.IconColor.setValue(this.iconColor);
  }

  iconSelected(icon:any){
    if(this.form.value.Icon == this.getIconClass(icon)){
      this.form.patchValue({
        Icon:'',
        IsIcon:false
      });
    } else {
      this.form.patchValue({
        Icon:this.getIconClass(icon),
        IsIcon:true
      });
    }
  }

  ngOnDestroy() { 
    this.subsink.unsubscribe();
  }
  
}
